import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import { enumUtil } from '../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import isNull from '../../../../../../../../utils/NullChecking';
import SuperSearchSingleClient from '../../../../../../../shared/SuperSearch/SingleSelection/SuperSearchSingleClient';
import Loader from '../../../../../../../shared/Loader/Loader';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';

const useClaimLinkingEncounter = (patientID, encounterID, setReloadAfterSave) => {
    const API_URL = enumUtil.controller.General;
    const [linkClaim, setLinkClaim] = useState(false);
    const [dropDownData, setDropDownData] = useState(false);
    const [is, setIs] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const ENCOUNTER_MODEL = {
        "ClaimID": "",
    }
    const [saveEncounterParam, setSaveEncounterParam] = useState(ENCOUNTER_MODEL);
    const SearchEncounterName = {
        "ClaimID": "",
    }
    const [searchValue, setSearchValue] = useState(SearchEncounterName)
    
    const handleSelectedData = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            setIs(true);
            if (name === 'ClaimID') {
                console.log("ClaimIDname", selectedData, name, type)
                setSaveEncounterParam({ ...saveEncounterParam, ClaimID: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, ClaimID: selectedData.value + "" }))
                // LoadEncounterData(selectedData);
            }
        } else {
            setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
            setSearchValue(prev => ({ ...prev, [name]: "" }))
        }
        return selectedData
    }

    const LoadDD = (date) => {
        if(!date) return;

        ServerRequestProtected(API_URL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.GIRPNote,
            "SearchCriteria": {
                "EncounterDate": date,
                "PatientID": patientID
            }
        })
        .then((response) => {
            setDropDownData(response)
        }).catch((error) => {
            setDropDownData([]);
        })
    }

    const handleSave = () => {
        if(!saveEncounterParam.ClaimID) return;
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.GIRPNote,    
            "ID" : encounterID,
            "Data": {   
                "ClaimID": saveEncounterParam.ClaimID
            }
        })
        .then((response) => {
            setIsLoading(false);
            setLinkClaim(false);
            setReloadAfterSave(true);
            // setDropDownData(response)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false);
            // setDropDownData([]);
        })
    }

    useEffect(() => {
        LoadDD();
    }, [])

    let divClaimLinking =
        <>
            <div className='d-flex align-items-center cursor-pointer' onClick={() => { setLinkClaim(true) }}>
                <p className={`heading fs-11 validate-color`} >Link Claim</p>
                <i className='icon-enrollment fs-13 lh-9'></i>
            </div>
            <Modal show={linkClaim} onHide={linkClaim} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 table-default-design pros-pend-popup">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className="d-flex align-items-center justify-content-between mb-12">
                        <p className="heading dark-clr fs-14">Link Claim</p>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={() => setLinkClaim(false)}></i>
                    </div>
                    {console.log("dropDownData dropDownData", dropDownData)}
                    <div className="">
                        <div className='input'>
                            <SuperSearchSingleClient
                                type="client"
                                id='ClaimID'
                                name='ClaimID'
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValue.ClaimID}
                                data={dropDownData}
                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, ClaimID: e.target.value }) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                                placeholder={false}
                                SuperSearchView="DetailedView"
                                DetailedView="LinkClaim"
                            />
                        </div>
                    </div>
                </Modal.Body>
                    <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => setLinkClaim(false)}>Cancel</button>
                    <button className='btn btn-validate px-10 h-100' onClick={handleSave}>Save </button>
                </div>
            </Modal>
        </>;
    let dataExist = dropDownData?.length > 0;
    //   return ({ divClaimLinking })
  return ({ divClaimLinking, LoadDD, dataExist });
}

export default useClaimLinkingEncounter